import type { Entrada } from './registro';

/** Cantidad de pendientes por nombre de contador (`Entrada.contador`). */
export type Contadores = Partial<Record<NonNullable<Entrada['contador']>, number>>;

export const contadorDe = (entrada: Entrada, contadores: Contadores): number =>
  entrada.contador ? (contadores[entrada.contador] ?? 0) : 0;
